import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    WalletConnectionProvider: null,
    walletType: "",
    walletAddress: "",
    walletAmount: null,
    walletConnector: null
}

export const walletConnectReducer = createSlice({
    name: 'walletConnection',
    initialState,
    reducers: {
        getWalletProvider: (state, action) => {
            console.log(action)
            console.log(state)
            state.WalletConnectionProvider = action.payload
        },
        setWalletType: (state, action) => {
            state.walletType = action.payload
        },
        setWalletAddress: (state, action) => {
            state.walletAddress = action.payload
        },
        setWalletAmount: (state, action) => {
            state.walletAmount = action.payload
        },
        setConnection: (state, action) => {
            console.log(action.payload)
            state.walletConnector = action.payload
        }
    },
})

// Action creators are generated for each case reducer function
export const { getWalletProvider, setWalletType, setWalletAddress, setWalletAmount, setConnection } = walletConnectReducer.actions

export default walletConnectReducer.reducer